
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { UnassignDispolistResponse_$reflection } from "../../../Shared/Dispolist.js";
import { TokenDataDto_$reflection, PostResponse$1_$reflection } from "../../../Shared/Shared.js";
import { record_type, bool_type, list_type, tuple_type, lambda_type, unit_type, union_type, class_type, option_type, anonRecord_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ToolBoxDispolist_$reflection } from "../../../Shared/Receiver.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none, Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../../Communication.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { empty as empty_1, toArray, map, ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { UnassignDispolist, UnassignDispolist_$reflection } from "../../../Shared/Tool.js";
import { onBlobReceived, getBlob } from "../../../CommunicationV2.js";
import { unwrapDispolistSnapshotId } from "../../../Shared/Helper.js";
import { Cmd_successToast } from "../../../Components/Toast.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton as singleton_1, empty, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { addPrefix as addPrefix_1, token as token_2 } from "../../../CommunicationV2.js";
import { fetch$ } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { DispolistSnapshotId__get_unwrap } from "../../../Shared/Shared.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { toLocalTime, toString as toString_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { InformationAlert } from "../../../Components/Alert.js";
import { Select } from "../../../Components/Select.js";
import { unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Button, TextButton } from "../../../Components/Button.js";
import Printer from "../../../../public/assets/icons/Printer.svg";
import { Table } from "../../../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnassignDispolist", "UnassignDispolistResponse", "SetSelectedDispolist", "ToolBoxDispolistFetched", "DownloadInventoryListPrinzing", "DownloadedInventoryListPrinzing", "BlobReceived", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("ToolBox.Detail.Dialog.UnassignDispolistDialog.Msg", [], Msg, () => [[], [["Item", PostResponse$1_$reflection(UnassignDispolistResponse_$reflection())]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", string_type]))]], [["Item", ToolBoxDispolist_$reflection()]], [], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

function getToolBoxDispolistCmd(userId, eventId) {
    return Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ToolBoxDispolist_$reflection()));
    })))), concat("/api/toolbox/", userId, "/dispolist/", ...eventId), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(7, [Item_1])));
}

function returnDispolistCmd(dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(UnassignDispolistResponse_$reflection())));
    })))), ["/api/dispolists/unassign-without-notification", toString(0, Auto_generateBoxedEncoder_437914C6(UnassignDispolist_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(7, [Item_1])));
}

class State extends Record {
    constructor(UserData, SuccessCallback, SelectedDispolist, DispolistIdsAndNames, OnClose, IsLoading, ToolBoxDispolist, SenderId) {
        super();
        this.UserData = UserData;
        this.SuccessCallback = SuccessCallback;
        this.SelectedDispolist = SelectedDispolist;
        this.DispolistIdsAndNames = DispolistIdsAndNames;
        this.OnClose = OnClose;
        this.IsLoading = IsLoading;
        this.ToolBoxDispolist = ToolBoxDispolist;
        this.SenderId = SenderId;
    }
}

function State_$reflection() {
    return record_type("ToolBox.Detail.Dialog.UnassignDispolistDialog.State", [], State, () => [["UserData", TokenDataDto_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["SelectedDispolist", option_type(anonRecord_type(["label", string_type], ["value", string_type]))], ["DispolistIdsAndNames", list_type(tuple_type(string_type, string_type, class_type("System.DateTime")))], ["OnClose", lambda_type(unit_type, unit_type)], ["IsLoading", bool_type], ["ToolBoxDispolist", option_type(ToolBoxDispolist_$reflection())], ["SenderId", string_type]]);
}

function init(dispolistIdsAndNames, successCallback, onClose, userData, senderId) {
    return [new State(userData, successCallback, undefined, dispolistIdsAndNames, onClose, false, undefined, senderId), Cmd_none()];
}

function update(msg, state) {
    let tempFilename;
    switch (msg.tag) {
        case 5:
            return [state, getBlob(msg.fields[0], msg.fields[1], (tupledArg_2) => (new Msg(6, [tupledArg_2[0], tupledArg_2[1]])), (Item_5) => (new Msg(7, [Item_5])))];
        case 6: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [new State(state.UserData, state.SuccessCallback, state.SelectedDispolist, state.DispolistIdsAndNames, state.OnClose, false, state.ToolBoxDispolist, state.SenderId), Cmd_none()];
        }
        case 3:
            return [new State(state.UserData, state.SuccessCallback, state.SelectedDispolist, state.DispolistIdsAndNames, state.OnClose, false, msg.fields[0], state.SenderId), Cmd_none()];
        case 0: {
            const matchValue_2 = state.ToolBoxDispolist;
            if (matchValue_2 == null) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.UserData, state.SuccessCallback, state.SelectedDispolist, state.DispolistIdsAndNames, state.OnClose, true, state.ToolBoxDispolist, state.SenderId), returnDispolistCmd(new UnassignDispolist(unwrapDispolistSnapshotId(matchValue_2.DispolistSnapshotId), state.SenderId))];
            }
        }
        case 2: {
            const selectedDispolist = msg.fields[0];
            if (selectedDispolist == null) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.UserData, state.SuccessCallback, selectedDispolist, state.DispolistIdsAndNames, state.OnClose, true, state.ToolBoxDispolist, state.SenderId), getToolBoxDispolistCmd(state.SenderId, selectedDispolist.value)];
            }
        }
        case 1:
            return [new State(state.UserData, state.SuccessCallback, state.SelectedDispolist, state.DispolistIdsAndNames, state.OnClose, false, state.ToolBoxDispolist, state.SenderId), Cmd_batch(ofArray([Cmd_ofEffect((_arg_1) => {
                state.SuccessCallback();
            }), Cmd_successToast("toolbox.dispolist_return_successful"), Cmd_ofEffect((_arg_2) => {
                state.OnClose();
            })]))];
        case 7:
            return [new State(state.UserData, state.SuccessCallback, state.SelectedDispolist, state.DispolistIdsAndNames, state.OnClose, false, state.ToolBoxDispolist, state.SenderId), Cmd_none()];
        default: {
            const matchValue = state.ToolBoxDispolist;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const toolboxDispolist = matchValue;
                return [new State(state.UserData, state.SuccessCallback, state.SelectedDispolist, state.DispolistIdsAndNames, state.OnClose, true, state.ToolBoxDispolist, state.SenderId), (tempFilename = concat("Werkzeugliste_", toolboxDispolist.DispolistName.trim(), ...".xlsx"), Cmd_OfPromise_either_1((tupledArg_1) => {
                    const body_1 = tupledArg_1[2];
                    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                            let matchValue_1_1;
                            return append((matchValue_1_1 = token_2(undefined), (matchValue_1_1 == null) ? (empty()) : singleton_1(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue_1_1]))), delay(() => singleton_1(new Types_HttpRequestHeaders(11, ["Content-Disposition"]))));
                        })), 0)])]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                            let matchValue_1;
                            return append((matchValue_1 = token_2(undefined), (matchValue_1 == null) ? (empty()) : singleton_1(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue_1]))), delay(() => singleton_1(new Types_HttpRequestHeaders(11, ["Content-Disposition"]))));
                        })), 0)])]);
                        return fetch$(addPrefix_1(tupledArg_1[0]), props).then((_arg) => (Promise.resolve([_arg, tupledArg_1[1]])));
                    }));
                }, [concat("/api/dispolists/export/excel/", ...DispolistSnapshotId__get_unwrap(toolboxDispolist.DispolistSnapshotId)), tempFilename, undefined], (tupledArg) => (new Msg(5, [tupledArg[0], tupledArg[1]])), (Item_2) => (new Msg(7, [Item_2]))))];
            }
        }
    }
}

function DialogBody(props) {
    let elems_4;
    const t = useTranslation()[0];
    const options = map((tupledArg) => ({
        label: concat(tupledArg[0], " - ", ...toString_1(toLocalTime(tupledArg[2]), "dd.MM.yyyy HH:mm")),
        value: tupledArg[1],
    }), props.DispolistIdsAndNames);
    return reactElement("div", createObj(ofArray([["id", "unassign-dispolist-dialog"], ["className", join(" ", ["grid", "gap-5", "p-4"])], (elems_4 = toList(delay(() => {
        let elems_2, elems_1;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "w-[35rem]", "gap-5"])], (elems_2 = [createElement(InformationAlert, {
            Label: t("toolbox.dispolist_return_msg"),
        }), createElement(Select, {
            ComponentState: props.FormState,
            IsClearable: false,
            NoOptionsMessage: "",
            OnChange: props.SetSelectedDispolist,
            Options: options,
            PlaceholderKey: "",
            TestId: "",
            Value: unwrap(props.SelectedDispolist),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_1 = toList(delay(() => {
            let matchValue, elems;
            return append((matchValue = props.Customer, (matchValue.tag === 1) ? ((props.ToolBoxDispolist != null) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mr-8"])], (elems = [createElement(TextButton, {
                ComponentState: props.FormState,
                Icon: Printer(),
                Label: "",
                OnClick: () => {
                    props.Dispatch(new Msg(4, []));
                },
                TestId: "excel-print-button",
                Variant: "default",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : (empty())) : ((matchValue.tag === 0) ? (empty()) : ((matchValue.tag === 3) ? (empty()) : ((matchValue.tag === 4) ? (empty()) : ((matchValue.tag === 5) ? (empty()) : ((matchValue.tag === 6) ? (empty()) : ((matchValue.tag === 7) ? (empty()) : ((matchValue.tag === 8) ? (empty()) : ((matchValue.tag === 9) ? (empty()) : ((props.ToolBoxDispolist != null) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mr-8"])], (elems = [createElement(TextButton, {
                ComponentState: props.FormState,
                Icon: Printer(),
                Label: "",
                OnClick: () => {
                    props.Dispatch(new Msg(4, []));
                },
                TestId: "excel-print-button",
                Variant: "default",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : (empty()))))))))))), delay(() => singleton_1(createElement(Button, {
                ComponentState: (props.ToolBoxDispolist == null) ? "disabled" : props.FormState,
                Label: t("general.take_back"),
                OnClick: () => {
                    props.Dispatch(new Msg(0, []));
                },
                TestId: "save-unassign-dispolist-dialog-test-id",
                Variant: "primary",
            }))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3, TableRows;
            const matchValue_2 = props.ToolBoxDispolist;
            if (matchValue_2 != null) {
                const dispolist = matchValue_2;
                return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-max"])], (elems_3 = [createElement(Table, (TableRows = toArray(dispolist.Rows), {
                    ColumnDefinitions: [new ColumnDefinition$1("elementType", "", t("general.tool_type"), (row) => (new CellContent(0, [t(row.ElementType)])), "none", "text"), new ColumnDefinition$1("name", "", t("general.tool"), (row_1) => (new CellContent(0, [row_1.Name])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_2) => (new CellContent(0, [row_2.Quantity])), "none", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (row_3) => (new CellContent(0, [row_3.Storage])), "none", "text")],
                    Controls: empty_1(),
                    Options: {
                        BorderStyle: "full",
                        CSVDownload: false,
                        ConfigurableColumns: false,
                        CustomTableFilters: false,
                        DefaultSortColumn: ["name", "asc"],
                        Fullscreen: false,
                        GlobalSearch: false,
                        RowSelection: "disabled",
                        SaveTableConfiguration: false,
                    },
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
            }
            else {
                return empty();
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function UnassignDispolistDialog(props) {
    const patternInput = useTranslation();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.DispolistIdsAndNames, props.SuccessCallback, props.OnClose, props.UserData, props.SenderId), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: createElement(DialogBody, {
            Customer: props.UserData.Customer,
            Dispatch: dispatch,
            DispolistIdsAndNames: state_1.DispolistIdsAndNames,
            FormState: state_1.IsLoading ? "disabled" : "enabled",
            SelectedDispolist: unwrap(state_1.SelectedDispolist),
            SetSelectedDispolist: (value) => {
                dispatch(new Msg(2, [value]));
            },
            ToolBoxDispolist: unwrap(state_1.ToolBoxDispolist),
        }),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput[0]("toolbox.dispolist_return"),
    });
}

